'use client';

import { datadogLogs } from '@datadog/browser-logs';
import type { LogRecord } from '@logtape/logtape';

let initialized = false;
const DATADOG_TOKEN = 'puba1ad5273bdb658063531500b18b763f8';

function initDatadog() {
  if (initialized || typeof window === 'undefined') {
    return;
  }

  initialized = true;

  datadogLogs.init({
    clientToken: DATADOG_TOKEN,
    site: 'datadoghq.com',
    service: 'medprev-web-app-frontend',
    env: 'production',
    sessionSampleRate: 100,
    forwardErrorsToLogs: false,
  });

  datadogLogs.setGlobalContext({
    version: String(process.env.NEXT_PUBLIC_GIT_COMMIT_SHA),
  });
}

export function getDatadogClientSink() {
  if (typeof window !== 'undefined') {
    setTimeout(initDatadog, 0);
  }

  return (record: LogRecord) => {
    if (!initialized) {
      return;
    }

    datadogLogs.logger[record.level]?.(
      record.message ?? '',
      record.properties ?? {},
    );
  };
}
